<script setup lang="ts">
import * as commonConstants from '@/constants/common';

export interface Props {
  term?: string;
}
const props = withDefaults(defineProps<Props>(), {
  term: commonConstants.EM_DASH,
});
</script>

<template>
  <div
    :class="$style.detailedJobInfoDescListItem"
    data-testid="detailedJobInfoDescListItem"
  >
    <dt :class="$style.dt">{{ props.term }}</dt>
    <dd :class="$style.dd">
      <slot>{{ commonConstants.EM_DASH }}</slot>
    </dd>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.detailedJobInfoDescListItem {
  line-height: 1.4;
}
  .dt {
    color: colors.$color-text-tertiary;
  }
  .dd {
    line-height: 1.2;
    margin: 6px 0 1px 0;
  }
</style>
